import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Eye, Printer, X } from "lucide-react";
import { format } from "date-fns";

const ReceiptPreviewModal = ({ isOpen, onClose, receipt }) => {
  if (!isOpen || !receipt) return null;

  const handlePrint = () => window.print();

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[150] bg-gray-900/60 backdrop-blur-sm no-print"
            onClick={onClose}
          />

          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 20 }}
            className="fixed inset-0 z-[160] flex items-center justify-center p-4 pointer-events-none"
          >
            <div className="w-full max-w-3xl rounded-3xl bg-white overflow-hidden shadow-2xl pointer-events-auto">
              <div className="px-6 py-4 bg-slate-900 flex items-center justify-between no-print">
                <div className="text-white">
                  <p className="text-xs uppercase tracking-wider font-bold opacity-70">Xem trước phiếu thu</p>
                  <h3 className="text-sm font-black mt-1">{receipt.receipt_code || "—"}</h3>
                </div>
                <div className="flex items-center gap-2">
                  <button
                    onClick={handlePrint}
                    className="h-10 px-4 rounded-xl bg-white/10 text-white text-xs font-bold uppercase tracking-wider flex items-center gap-2"
                  >
                    <Printer size={14} />
                    In
                  </button>
                  <button
                    onClick={onClose}
                    className="h-10 w-10 rounded-xl bg-white/10 text-white"
                  >
                    <X size={16} className="mx-auto" />
                  </button>
                </div>
              </div>

              <div className="p-8">
                <div className="text-center">
                  <h2 className="text-2xl font-black text-gray-900 uppercase">Phiếu thu</h2>
                  <p className="text-xs text-gray-500 font-bold uppercase tracking-wider mt-1">
                    Mã: {receipt.receipt_code || "—"}
                  </p>
                </div>

                <div className="mt-8 grid grid-cols-2 gap-6">
                  <Info label="Ngày thu" value={receipt.receipt_date ? format(new Date(receipt.receipt_date), "dd/MM/yyyy") : "—"} />
                  <Info label="Chi nhánh" value={receipt.branch_name || "—"} />
                  <Info label="Người nộp" value={receipt.payer_name || "—"} />
                  <Info label="Loại đối tượng" value={receipt.payer_type || "—"} />
                  <Info label="Phương thức" value={receipt.payment_method || "—"} />
                  <Info label="Trạng thái" value={receipt.status || "—"} />
                </div>

                <div className="mt-6 p-4 rounded-2xl bg-gray-50 border border-gray-100">
                  <p className="text-[11px] font-black uppercase tracking-wider text-gray-400">Lý do thu</p>
                  <p className="mt-1 text-sm font-medium text-gray-700">{receipt.reason || "—"}</p>
                </div>

                <div className="mt-6 text-right">
                  <p className="text-[11px] font-black uppercase tracking-wider text-gray-400">Tổng tiền</p>
                  <p className="text-3xl font-black text-red-700">
                    {Number(receipt.amount || 0).toLocaleString("vi-VN")} VND
                  </p>
                </div>
              </div>

              <div className="px-6 py-4 border-t border-gray-100 bg-gray-50 no-print flex justify-end">
                <button
                  onClick={onClose}
                  className="h-10 px-6 rounded-xl bg-slate-900 text-white text-xs font-black uppercase tracking-wider flex items-center gap-2"
                >
                  <Eye size={14} />
                  Đóng
                </button>
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

const Info = ({ label, value }) => (
  <div>
    <p className="text-[11px] font-black uppercase tracking-wider text-gray-400">{label}</p>
    <p className="text-sm font-semibold text-gray-800 mt-1">{value}</p>
  </div>
);

export default ReceiptPreviewModal;
